import React, {useEffect, useState} from 'react';
import AdminHeader from "../UI/AdminHeader";
import AdminFilters from "../UI/AdminFilters";
import AdminCharts from "../AdminChart/AdminChart";
import _axios from "../../../httpService";
import Loader from "../../Loader";

const AnalyseA = (props) => {
  const [filterDataPart, setFilterDataPart] = useState("0")
  const [isLoading, setIsLoading] = useState(false);
  const [dataTemp, setDataTemp] = useState([]);
  const [typeTemp, setTypeTemp] = useState([]);
  const [titleTemp, setTitleTemp] = useState([]);
  const [optionsTemp, setOptionsTemp] = useState([]);


  useEffect(() => {
    setIsLoading(true);
    let url = "";
    if (props.filterType === "type1") {
      if (filterDataPart !== "0") {
        url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part + "&filter=" + JSON.stringify({
          type: 'task',
          programmerId: filterDataPart
        }) + "";
      } else {
        url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part + "&filter=" + JSON.stringify({
          type: 'all',
          programmerId: filterDataPart
        }) + "";
      }
    } else if (props.filterType === "type2") {
      url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part + "&filter=" + JSON.stringify({
        type: 'all', year: "", month: ''
      }) + ""
    }
    _axios.get(url
      // +"&part2Filter="+ JSON.stringify({type:'all', year:1401, month:''})+""
    )
      .then(data => {
        const localDataTemp = [];
        const localTypeTemp = []
        const localTitleTemp = []
        const localOptionsTemp = []
        data = data.data;
        console.log(data)
        for (let key in data) {
          for (const key2 in data[key]) {
            localDataTemp.push(data[key][key2].data)
            localTypeTemp.push(data[key][key2].type)
            localTitleTemp.push(data[key][key2].title)
            localOptionsTemp.push(data[key].options)
          }
        }

        setDataTemp(localDataTemp)
        setTypeTemp(localTypeTemp);
        setTitleTemp(localTitleTemp)
        setOptionsTemp(localOptionsTemp)
        setIsLoading(false)
      })

    console.log(dataTemp.length);
  }, [filterDataPart]);

  return (
    <div>
      <AdminHeader BgColor={props.BgColor}>
        {props.HeaderText}
      </AdminHeader>
      {props.filterType !== undefined && <AdminFilters filterType={props.filterType} onFilter={setFilterDataPart}/>}

      {isLoading === true ? <Loader/> :
        <div className={"row"}>
          {
            dataTemp.map((v, i) =>
              <AdminCharts
                key={i*0.002}
                type={typeTemp[i]}
                title={titleTemp[i]}
                options={optionsTemp[i]}
                data={v}
                className={props.className}
              />
            )
          }
        </div>}
    </div>
  );
};

export default AnalyseA;
